import type { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { RequireAuth } from './components/RequireAuth';
import { LoginPage } from './pages/LoginPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { DashboardPage } from './pages/DashboardPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { NotesDeVersionPage } from './pages/NotesDeVersionPage';
import { UsersPage } from './pages/admin/UsersPage';
import { ArticlesPage } from './pages/referentiels/ArticlesPage';
import { CommentTypesPage } from './pages/referentiels/CommentTypesPage';
import { RestantPage } from './pages/RestantPage';
import { RapprochementsPage } from './pages/RapprochementsPage';
import { ReconciliationTypesPage } from './pages/referentiels/ReconciliationTypesPage';
import { MovementTypesPage } from './pages/referentiels/MovementTypesPage';
import { FamiliesPage } from './pages/referentiels/FamiliesPage';
import { CopackingCoherencePage } from './pages/referentiels/CopackingCoherencePage';
import { ImportsPage } from './pages/imports/ImportsPage';
import { RapprochementPage } from './pages/RapprochementPage';
import { EcartsPage } from './pages/EcartsPage';
import { FicheEcart } from './pages/ecarts/FicheEcart';
import { CloturePage } from './pages/CloturePage';

export function App(): ReactElement {
  return (
    <Routes>
      <Route path="/connexion" element={<LoginPage />} />

      <Route
        path="/changer-mot-de-passe"
        element={
          <RequireAuth allowPendingPasswordChange>
            <ChangePasswordPage />
          </RequireAuth>
        }
      />

      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/" element={<Navigate to="/tableau-de-bord" replace />} />
        <Route path="/tableau-de-bord" element={<DashboardPage />} />
        <Route path="/imports" element={<ImportsPage />} />
        <Route path="/rapprochement" element={<RapprochementPage />} />
        <Route path="/ecarts" element={<EcartsPage />} />
        <Route path="/restant" element={<RestantPage />} />
        <Route path="/restant/historique" element={<RapprochementsPage />} />
        {/* L'ancienne adresse reste valide : un lien deja partage doit continuer
            d'ouvrir l'ecran, pas une page blanche. */}
        <Route path="/rapprochements" element={<Navigate to="/restant/historique" replace />} />
        <Route path="/referentiels/types-de-commentaire" element={<CommentTypesPage />} />
        <Route
          path="/referentiels/types-de-rapprochement"
          element={<ReconciliationTypesPage />}
        />
        <Route path="/ecarts/:code" element={<FicheEcart />} />
        <Route path="/cloture" element={<CloturePage />} />
        <Route path="/notes-de-version" element={<NotesDeVersionPage />} />
        <Route path="/referentiels" element={<Navigate to="/referentiels/articles" replace />} />
        <Route path="/referentiels/articles" element={<ArticlesPage />} />
        <Route path="/referentiels/types-de-mouvements" element={<MovementTypesPage />} />
        <Route path="/referentiels/familles" element={<FamiliesPage />} />
        <Route path="/referentiels/copacking" element={<CopackingCoherencePage />} />
        <Route
          path="/administration/utilisateurs"
          element={
            <RequireAuth roles={['ADMIN']}>
              <UsersPage />
            </RequireAuth>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
